import gql from "graphql-tag";
import graphqlClient from "@/http/graphql/link";

const GET_TAGS = `
    tags (limit: $limit,page: $page) {
		data {
			id
			name
			taggables_count
		}
	}
`;
const UPDATE_TAG = `
	update_tag(
		id: $id,
		name: $name
  	) {
		id
		name
  	}
  `;
const ADD_TAG = `add_tag(
	name: $name
  ) {
	id
	name
  }`;
export default {
	init() {},

	fetchTags(payload) {
		const queryOptions = {
			query: gql`query Tags ($limit: Int!, $page: Int!) {
				${GET_TAGS}
			}`,
			variables: {
				limit: payload.limit || -1,
				page: payload.page || 1
			}
		};

		return graphqlClient.query(queryOptions).then(response => {
			return {
				tags: response.data.tags.data
			};
		});
	},
	updateTag(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation UpdateTag (
					$id: Int!,
					$name: String!
				) {
					${UPDATE_TAG}
				}
			`,
				variables: {
					id: payload.id,
					name: payload.name
				}
			})
			.then(response => response.data.update_tag);
	},
	addTag(payload) {
		return graphqlClient
			.mutate({
				mutation: gql`mutation AddTag (
					$name: String!
				) {
					${ADD_TAG}
				}
			`,
				variables: {
					name: payload.name
				}
			})
			.then(response => response.data.add_tag);
	}
};
